import { render, staticRenderFns } from "./ReportCardDetail.vue?vue&type=template&id=8dc4912e&scoped=true"
import script from "./ReportCardDetail.vue?vue&type=script&lang=ts"
export * from "./ReportCardDetail.vue?vue&type=script&lang=ts"
import style0 from "./ReportCardDetail.vue?vue&type=style&index=0&id=8dc4912e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc4912e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EmptyState: require('/app/components/Common/EmptyState.vue').default,UIReportCardGrade: require('/app/components/Common/UI2/Grade/UIReportCardGrade.vue').default,ReportCardDimensionRow: require('/app/components/Run/ReportCard/ReportCardDimensionRow.vue').default})
